import type { RootState, SelectorCreator, Slicer } from '@swf/core/store';

import type { StepKey } from '../types';

import type { PokerPowerPathState } from './types';

export const selectors = (slice: Slicer<PokerPowerPathState>, createSelector: SelectorCreator) => ({
  isLoading: () => slice((state) => state.isLoading),
  getStepByKey: () =>
    createSelector(
      slice,
      (_: RootState, stepKey: StepKey) => stepKey,
      (state, stepKey) => state.steps[stepKey]
    ),
  getPasses: () => slice((state) => state.passesData)
});
